<template>

    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: 'App'
    }
</script>

<style>

    * {
        margin: 0;
        padding: 0;
    }

    body {
        position: fixed;
        width: 100vw;
        height: 100vh;
    }

    #geo-map .BMap_cpyCtrl{
       display: none;
    }
 
    #geo-map .anchorBL{
       display: none;
    }

    .BMap_stdMpZoomIn .BMap_smcbg {
        background-image: url(./assets/images/search/plus.png) !important;
        background-size: 40% 40% !important;
    }

    .BMap_stdMpZoomOut .BMap_smcbg {
        background-image: url(./assets/images/search/minus.png) !important;
        background-size: 40% 10% !important;
    }

    .BMap_stdMpType4 .BMap_stdMpZoom {
        background-color: #1119a0 !important;
    }

    .BMap_button .BMap_stdMpZoomOut {
        border-top: 1px solid #1119a0 !important;
    }

    .BMap_stdMpType4 .BMap_stdMpZoom .BMap_button {
        border: 1px solid #0B9FE0 !important;
    }

    .BMap_stdMpCtrl,
    .BMap_stdMpZoom {
        height: 50px !important;
        width: 25px !important;
        position: absolute !important;
        bottom: 0rem !important;
        right: 0rem !important;
    }

    .BMap_stdMpZoomIn,
    .BMap_smcbg,
    .BMap_stdMpZoomOut,
    .BMap_smcbg {
        height: 25px !important;
        width: 25px !important;
    }
</style>
